import { BadgeServiceService } from './../services/badgeService/badge-service.service';
import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import {ErrorStateMatcher} from '@angular/material/core';
import {MatDialog} from '@angular/material/dialog';
import { Router } from '@angular/router';

export interface User {
  id: number,
  employerName: string,
  county: string,
  address: string,
  email: string,
  paName: string,
  image: string
}

/** Error when invalid control is dirty, touched, or submitted. */
export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-user-details-forum',
  templateUrl: './user-details-forum.component.html',
  styleUrls: ['./user-details-forum.component.css']
})

export class UserDetailsForumComponent implements OnInit {

  splitPathName: string[] = document.location.pathname.split('/'); // Extracts the IIS application name from url

    //Local
    //url: string =`${document.location.protocol}//${document.location.host}/${this.splitPathName[1]}/assets/images/placeholderimage.png`;
    //Live
    url: string =`${document.location.protocol}//${document.location.host}/${this.splitPathName[1]}/PABadgesFreeLive/assets/images/placeholderimage.png`;

  count: number = 0;

  isEdit: boolean = false;

  address: string = "Jason";

  confirmEmail: string = "";

  user: User = {
    employerName: '',
    county: '',
    address:'Please enter address' ,
    email: '',
    paName: '',
    image: '',
    id: 1
  };

  hideBadgeInfo: boolean = false;

  employeeNameControl = new FormControl('', [
    Validators.required
  ]);

  employeeEmailControl = new FormControl('', [
    Validators.required,
    Validators.email
  ]);

  paNameControl = new FormControl('', [
    Validators.required
  ]);

  confirmEmailControl = new FormControl('', [
    Validators.required
  ]);

  matcher = new MyErrorStateMatcher();

  constructor(public dialog: MatDialog, private _badgeService: BadgeServiceService, private _router: Router) {
    this._badgeService.editUserObservable.subscribe((value) => {
      setTimeout(() => {
        this.editUser(value);
      }, 0)
    });
  }
n
  ngOnInit(): void {

   
    this.user = this._badgeService.selectedUser;

    //Local
    //this.url = `${document.location.protocol}//${document.location.host}/assets/images/placeholderimage.png`;
    //Live
    this.url = `${document.location.protocol}//${document.location.host}/PABadgesFreeLive/assets/images/placeholderimage.png`;

    this.confirmEmail = this.user.email;
    this.address = this.user.address;
    this.isEdit = this._badgeService.editUser;
    const emailChecker = () => {
      const email = this.user.email;
      const confirm = this.confirmEmail;
      return email === confirm ? null : { emailConfirm: 'Email confirm mismatch' };
    };
    this.confirmEmailControl.setValidators([emailChecker]);
    this.setWindow();
  }

  editUser(user: User): void {
    // console.log(user.employerName);
    // this.user.employerName = user.employerName;
    // this.isEdit = true;
    // console.log(this.user);
    // console.log(this.isEdit);

  }

  openDialog() {
    this.dialog.open(DialogExampleBadge);
  }

  checkEmail(): boolean {
    if (this.user.email === this.confirmEmail) {
      this.confirmEmailControl.setErrors(null);
      return false;
    }
    return true;
  }

  onAddressLookup(event: any): void {
    this.user.address = event.formatted_address;
    for (const prop in event.address_components) {
      if (event.address_components[prop].types[0] == "administrative_area_level_2") {
        this.user.county = event.address_components[prop].long_name;
      }
    }
  }

  onselectFile(e: any): void {
    //console.log(e);
    if (e.target.files) {
        var reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        //console.log((e.target.files[0]));
        var fileType = e.target.files[0].type;
        //console.log(fileType);
        
        if (fileType.includes("image") === false) {
          alert("Incorrect file type. Please upload - jpeg, png or jpg image.");
          return;
        }
       
        reader.onload=(event:any)=>{
        this.url = event.target.result;
        this.user.image = this.url;
      }
    }   
  }

  lol(): void {
    //console.log(this.employeeNameControl.hasError('required'));
    //console.log(this.user);
  }

  saveToBasket(): void {
    var hasError = false;
    hasError = this.checkUserObject();
    if (hasError) {
      alert("Complete all fields before saving.");
      return;
    }
    // Check if user has already added badge with same email address
    var findIndex = this._badgeService.users.findIndex(x => x.paName === this.user.paName);
    if (findIndex !== -1) {
      alert("Badge already added exists for personal assistant.");
      return;
    }
    this.count++;
    this.user.id = this.count + 1;
    var deepCopy = JSON.parse(JSON.stringify(this.user));
    this._badgeService.users.push(deepCopy);
    this._badgeService.usersObservable.next(this._badgeService.users);

    // Inform user badge has been successfully added to basket
    alert("Badge has been added to basket.");

    // Grey out fields as all information will be the same apart from the PA name
    this.employeeEmailControl.disable();
    this.confirmEmailControl.disable();
    this.employeeNameControl.disable();

    // Reset Name and picture
    this.paNameControl.reset();
    //Local
    //this.url = `${document.location.protocol}//${document.location.host}/assets/images/placeholderimage.png`;
    //Live
    this.url = `${document.location.protocol}//${document.location.host}/PABadgesFreeLive/assets/images/placeholderimage.png`;
    this.user.image = '';
    this.user.paName = '';

  }

  editBadge(): void {
    var findIndex = this._badgeService.users.findIndex(x => x.paName === this.user.paName);
    if (findIndex !== -1) {
      this._badgeService.users[findIndex] = this.user;
      this._badgeService.usersObservable.next(this._badgeService.users);
      this._router.navigate(["/checkout"]);
    }
  }

  checkUserObject(): boolean {
    for(const prop in this.user) {
      if (this.user[prop] == "" && this.user[prop] !== 0) {
        return true;
      }
    }
    return false;
  }

  onResize(): void {
    this.setWindow();
  }

  setWindow(): void {
    if (window.innerWidth <= 810 ) {
      this.hideBadgeInfo = true;
    } else {
      this.hideBadgeInfo = false;
    }
  }

}

@Component({
  selector: 'dialog-example-badge',
  templateUrl: 'dialog-example-badge.html',
})
export class DialogExampleBadge {}